export interface IDoor {
  checkLP: Function;
  liveData: ILiveData[];
}

export interface IButtons {
  error: boolean;
  seconds: number;
  setSeconds: Function;
  setIsOpen: Function;
  checkLP: Function;
}

export interface IStyles {
  [x: string]: string;
}

export interface IMessages {
  error: boolean;
  seconds: number;
  setSeconds: Function;
}

export interface IReqBody {
  carParkId: string;
  lpNumber: string;
  deviceId: string;
}

export interface IParking {
  name: string;
  url: string;
}

export interface ILiveData {
  id: string;
  parkingId?: string;
  url: string;
  address: string;
  width: string;
  height: string;
  name: string;
  total: number;
  updatedTime: string | Date;
  createdAt?: string | Date;
  price: string;
  free: number;
  shortTerm: number;
}

// Mirrors the backend FileType enum; sent as the `fileType` param to POST /file/upload.
export enum ImageType {
  USER_PROFILE_IMAGE = "USER_PROFILE_IMAGE",
  HOME_BANNER_IMAGE = "HOME_BANNER_IMAGE",
  SHOP_BANNER_IMAGE = "SHOP_BANNER_IMAGE",
  SHOP_PROFILE_IMAGE = "SHOP_PROFILE_IMAGE",
  SHOP_BACKGROUND_IMAGE = "SHOP_BACKGROUND_IMAGE",
  BLOG_IMAGE = "BLOG_IMAGE",
  BUILDER_IMAGE = "BUILDER_IMAGE",
}
